<template lang="pug">
  include ./../../../mixins
  +b.recaptcha
    +e.VUE-RECAPTCHA.wrapper(
      ref="recaptcha",
      @verify="onVerify",
      @expired="onExpired",
      :sitekey="captchaKey"
      size="invisible"
    )
</template>

<script>
import VueRecaptcha from 'vue-recaptcha'

export default {
  components: {
    VueRecaptcha,
  },
  props: {
    recaptchaResetTrigger: Boolean,
    value: {},
  },
  data() {
    return {
      captchaKey: window.captchaKey,
    }
  },
  watch: {
    recaptchaResetTrigger: {
      handler() {
        this.recaptchaReset()
      },
    },
  },
  methods: {
    recaptchaReset() {
      this.$refs.recaptcha.reset()
    },
    onVerify(response) {
      this.$emit('verify', response)
    },
  },
}
</script>



// WEBPACK FOOTER //
// src/js/components/app/UiElements/UiRecaptcha.vue